import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
})
export class NotFoundComponent {}
